<template>
  <v-sheet :light="true" min-height="400" min-width="600">
    <v-data-table
      :items="allTools"
      :headers="headers"
      :disable-pagination="true"
      :hide-default-footer="true"
      class="pointer"
    >
      <template v-slot:[`item.description`]="{ item }">
        <router-link :to="link(item)" class="link">{{
          item.description
        }}</router-link>
      </template>
      <template v-slot:[`item.assign`]="{ item }">
        <v-checkbox
          :value="item.name"
          v-model="selected"
          @change="save"
          v-on:clink.prevent
          class="js-tool-assign"
        >
        </v-checkbox>
      </template>
    </v-data-table>
  </v-sheet>
</template>

<script>
import BaseAssignment from "@/components/BaseAssignment"
import titleMixin from "@/mixins/titleMixin"

export default {
  mixins: [titleMixin],
  components: {
    BaseAssignment
  },
  computed: {
    id() {
      return this.$route.params.id
    },
    allTools() {
      return this.$store.getters["tools/getTools"]
    },
    availableTools() {
      return this.allTools.filter(
        el => !this.selectedTools.map(el => el.tool_id).includes(el.tool_id)
      )
    },
    selectedTools() {
      return this.$store.getters["tools/getAssignedTools"](this.id)
    }
  },
  data: function() {
    return {
      headers: [
        {
          text: "Description",
          value: "description",
          sortable: true
        },
        {
          text: "Assigned",
          value: "assign",
          width: "130px"
        }
      ],
      selected: [],
      title: "Tool Assignments"
    }
  },
  async created() {
    this.load()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.load()
    }
    next()
  },
  methods: {
    link(row) {
      return { name: `${row.name}Mentor`, params: { userId: this.id } }
    },
    async load() {
      await this.$store.dispatch("tools/loadTools")
      await this.$store.dispatch("tools/loadAssignedTools", this.id)

      this.available = this.availableTools.map(el => el.name)
      this.selected = this.selectedTools.map(el => el.name)
    },
    async save() {
      let toUnassign = this.selectedTools.filter(
        el => !this.selected.includes(el.name)
      )

      let toAssign = this.availableTools.filter(el =>
        this.selected.includes(el.name)
      )

      let id = this.id
      for (const el of toAssign) {
        await this.$store.dispatch("tools/assignTool", {
          name: el.name,
          userId: id
        })
      }
      for (const el of toUnassign) {
        await this.$store.dispatch("tools/unassignTool", el.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.link {
  color: $dark-yellow;
}

.pointer {
  cursor: pointer;
}
</style>
